import './styles/index.sass';

import * as cookie from 'cookie';
import $ from 'jquery';
import { WOW } from 'wowjs';

const RESTRICTED_COUNTRIES = ['US'];

document.addEventListener('DOMContentLoaded', () => {
  if (document.cookie) {
    try {
      const cookies = cookie.parse(document.cookie);

      const country = cookies['country'];

      if (country && !RESTRICTED_COUNTRIES.includes(country)) {
        $('body').addClass('authorized');
      }
    } catch (error) {}
  }

  new WOW().init();

  $('.tab_item').not(':first').hide();
  $('.wrapper .tab').click(function() {
    $('.wrapper .tab').removeClass('active').eq($(this).index()).addClass('active');
    $('.tab_item').hide().eq($(this).index()).fadeIn()
  }).eq(0).addClass('active');

  $('.phone').click(function (){
    const $div = $(this).data('div');

    $('html, body').animate({
      scrollTop: $('#' + $div).offset().top
    }, 1000);
  });

  $('.down2').click(function() {
    const $div = $(this).data('div');

    $('html, body').animate({
      scrollTop: $('#' + $div).offset().top
    }, 1000);
  });

  $('.main-container').show();
});
